import { Suspense } from 'react';

import { Skeleton } from '@mui/material';

import { lazyImport } from '../Main/utils';

const ViewExportComponent = lazyImport(
  () => import('./ViewExportComponent'),
  'ViewExportComponent',
);

const ViewExportContainer = (props) => (
  <Suspense
    fallback={
      <Skeleton
        width={80}
        height={40}
        variant="rounded"
        sx={{ borderRadius: '1rem' }}
      />
    }
  >
    <ViewExportComponent {...props} />
  </Suspense>
);

export default ViewExportContainer;
